export default __webpack_public_path__ + "images/0x3712871408a829c5cd4e86da1f4ce727efcd28f6.png";